import axios from 'axios'

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
if (window.location.hostname != 'localhost')
  axios.defaults.baseURL = 'https://us-central1-bg-link-v2.cloudfunctions.net/app';
else
  axios.defaults.baseURL = 'http://localhost:5001/bg-link-v2/us-central1/app';

export default axios
